import '../../pages-css/home-page-css/page-layout-handler.css';

const OfferBanner =()=>{
    return(
        <div className="section-2">
        <div className="home-page-banner">
            <h1>Men's fashion | Clearance sale</h1>
            <h2>Upto 65% Off</h2>
            <h4>Starting at </h4>
            <p className="font-size-s">INR 399/-</p>
        </div>
    </div>
    )
}

export default OfferBanner;

















